import { FormControl, FormGroup } from "@angular/forms";
import { Address } from "./address.model";

export type InvoicingAddressForm = FormGroup<{
  name: FormControl<string>;
  company: FormControl<string>;
  street1: FormControl<string>;
  street2: FormControl<string>;
  city: FormControl<string>;
  state: FormControl<string>;
  zip: FormControl<string>;
  country: FormControl<string>;
  phone: FormControl<string>;
  email: FormControl<string>;
  sendFrom: FormControl<string>;
  copyTo: FormControl<string[]>;
}>;

export class InvoicingAddress extends Address {
  copyTo: string[];
  sendFrom: string;

  constructor(data?: Partial<InvoicingAddress>) {
    super(data);
    this.copyTo = data?.copyTo ?? [];
    this.sendFrom = data?.sendFrom ?? '';
  }
}
